<template>
  <div class="profile-view-advocacy-template">
    <div class="resource-item-container">
      <div class="resource-body" v-for="(stuff, indx) in info.userAdvocacies.careplans" v-if="stuff.careplan.is_approved && stuff.careplan.type!='report_concern' && stuff.careplan.type!='suggestion_box' && stuff.careplan.type!='menu' && stuff.careplan.type!='video' && stuff.careplan.type!='maintainance'" :key="indx">
        <div v-if="!stuff.careplan">
          <FeedListView :avatar="groupDisplayImage(stuff)"
            :title="stuff.title"
            :item="stuff"
            :poster="stuff.careplan.type"
            @emitContainer="onTriggerStuff(stuff)"></FeedListView>
        </div>
        <div v-if="stuff.careplan">
          <div>
            <FeedListView :avatar="stuff.careplan.thumbnail_photo"
              :title="stuff.careplan.title"
              :item="stuff"
              :poster="stuff.careplan.type"
              @emitContainer="onTriggerStuff(stuff)"></FeedListView>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FeedListView from "@/components/FeedListView";
  import Utils from '@/utils.js'

  export default {
    components: { FeedListView },
    methods: {
      groupDisplayImage(stuff) {
        return Utils.getDisplayImage('group', stuff, 'small')
      },
      onTriggerStuff(data) {
        this.$router.push("/resources/" + data.careplan_id);
      },
      loadGroups() {
        this.$store.dispatch('publicProfile/getUserAdvocacies', {id:this.uid});
      }
    },
    watch: {
      '$route': function(n,o) {
        if (n) this.loadGroups()
      }
    },
    mounted() {
      this.loadGroups()
    },
    computed: {
      info: {
        get() {
          return this.$store.state.publicProfile.info
        }
      }
    },
    props: {
      uid: {
        required: true,
        type: String
      }
    }
  }
</script>

<style scoped></style>
